import React from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';

const TITLES = {
  '/dashboard': 'Dashboard',
  '/purchases': 'Purchases',
  '/aggregation': 'Aggregation',
  '/discounts': 'Discounts',
  '/members': 'Members',
  '/brands': 'Brands',
  '/groups': 'Groups',
  '/suppliers': 'Suppliers',
  '/financials': 'Financials',
  '/trial-balance': 'Trial Balance',
  '/journal-entries': 'Journal Entries',
  '/tax': 'Tax',
  '/month-end': 'Month / Year End',
  '/reconciliation': 'Bank Reconciliation',
  '/fixed-assets': 'Fixed Assets',
  '/ageing': 'Ageing Analysis',
};

const Header = ({ user, onLogout, onMenuToggle }) => {
  const { pathname } = useLocation();
  const title = TITLES[pathname] || 'Workspace';

  return (
    <header className="header">
      <div className="header-left">
        <button
          type="button"
          className="header-menu"
          onClick={onMenuToggle}
          aria-label="Open menu"
        >
          ☰
        </button>
        <div>
          <p className="header-eyebrow">Workspace</p>
          <h1 className="header-title">{title}</h1>
        </div>
      </div>
      <div className="header-right">
        <div className="header-user">
          <span className="header-avatar">{(user?.username || '?').slice(0, 1).toUpperCase()}</span>
          <div className="header-user-text">
            <strong>{user?.username}</strong>
            <small>{user?.role || 'user'}</small>
          </div>
        </div>
        <button type="button" className="btn btn-outline header-logout" onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
